export const EXSBPRICELIST_DELETE_RESET = 'EXSBPRICELIST_DELETE_RESET'
export const EXSBPRICELIST_DELETE_SET_ERROR = 'EXSBPRICELIST_DELETE_SET_ERROR'
export const EXSBPRICELIST_DELETE_SET_DELETED = 'EXSBPRICELIST_DELETE_SET_DELETED'
export const EXSBPRICELIST_DELETE_TOGGLE_LOADING = 'EXSBPRICELIST_DELETE_TOGGLE_LOADING'
